import React from "react";
import StatusBadge from "../status-badge";

// Celda de una columna de estado: el texto que devuelve la columna (su `Cell`
// o el valor del `accessor`) se muestra con StatusBadge. Si la celda ya
// devuelve un elemento, se respeta tal cual.
const createStatusCell = (Cell) => (cellInfo) => {
  const content = typeof Cell === "function" ? Cell(cellInfo) : cellInfo.value;
  if (typeof content !== "string" && typeof content !== "number") return content;

  const text = String(content).trim();
  return text ? <StatusBadge>{text}</StatusBadge> : content;
};

export default createStatusCell;
